"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlowSourceApp = 'glow';
exports.AnywhereExpertSourceApp = 'anywhere-expert';
exports.UBIFSourceApp = 'ubif-portal';
var SourceApp;
(function (SourceApp) {
    SourceApp["GlowSourceApp"] = "glow";
    SourceApp["AnywhereExpertSourceApp"] = "anywhere-expert";
    SourceApp["UBIFSourceApp"] = "ubif-portal";
    SourceApp["SalesTool"] = "sales-tool";
})(SourceApp = exports.SourceApp || (exports.SourceApp = {}));
